import { create } from 'zustand';

/**
 * A monotonic version bumped whenever live FX rates are (re)synced into the
 * currency-service module state (LR-469).
 *
 * The actual rates live in the React-independent currency-service module (so the
 * pure aggregation utils and the click-time CSV export can read them without a
 * hook). This store exists ONLY to give React consumers a reactive dependency:
 * the on-page currency roll-ups (the Trades / MTM footer ≈-totals and the currency
 * pill's Σ≈ total) are computed inside `useMemo`s that call `getExchangeRate`, so
 * without a reactive signal they would stay frozen on the fallback-rate figure
 * (with the ⚠ "approximate" marker) after a cold-load race where `/fx-rates/`
 * resolves AFTER the table already rendered. `useFxRatesSync` bumps `version` once
 * the live rates land; consumers subscribe to it and add it to their roll-up memo
 * deps so the total recomputes against the fresh rates.
 */
interface FxRatesStore {
  version: number;
  bumpVersion: () => void;
}

export const useFxRatesStore = create<FxRatesStore>((set) => ({
  version: 0,
  bumpVersion: () => set((s) => ({ version: s.version + 1 })),
}));
